import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../Layout";
import useUserStore from "../../../utils/storeApp";
import HeaderNotify from "./HeaderNotify";
import CallAPI from "../../../services/apiCalls";
import $ from "jquery";

const NotifyApp = () => {
  const navigate = useNavigate();
  const { isUserLogedIn, userRole, userToken, SetSharedObject } = useUserStore(
    (state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
    })
  );

  const [URL, SetURL] = useState("");
  const [processingDetails, setProcessingDetails] = useState(false);

  useEffect(() => {
    setProcessingDetails(true);
    GetURL();
  }, []);

  const GetURL = async () => {
    let call = "/notifyApp/GetURL";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      var url = res.data;
      SetURL(url);
    } else if (res.status === "SERVERERROR") {
      //setProcessing(false);
    }
  };

  function finishedLoading() {
    setProcessingDetails(false);
  }
  return (
    <Layout>
      <HeaderNotify />
      <section className="layout-container">
        <div class="right-content-padding">
          <iframe
            id="iframeId"
            src={URL}
            frameborder="0"
            onLoad={finishedLoading}
          ></iframe>
          {processingDetails ? (
            <div
              className="modal fade show"
              id="detailsOrgModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="DetailsOrganization"
              aria-hidden="false"
              style={{ display: "block" }}
            >
              <div className="loading"></div>
            </div>
          ) : null}
        </div>
      </section>
    </Layout>
  );
};

export default NotifyApp;
